import { Component } from '@angular/core';
import { PopulationQuery } from '@fgb/core';
import { Populations } from 'src/app/shared/utilities/populations';

@Component({
  selector: 'fgb-challenges-page',
  templateUrl: './challenges-page.component.html',
  styleUrl: './challenges-page.component.scss',
})
export class ChallengesPageComponent {
  isKid: boolean;
  isClub1901: boolean;
  populations = Populations;
   constructor(
      private populationQuery: PopulationQuery
    ) {}
  ngOnInit() {
      this.isKid = this.populationQuery.userInPopulation([this.populations.Kids]);
      this.isClub1901 = this.populationQuery.userInPopulation([this.populations.Club1901]);
    }
}
